import { render, staticRenderFns } from "./modal-historico-solicitacao.vue?vue&type=template&id=775dc291&scoped=true"
import script from "./modal-historico-solicitacao.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-solicitacao.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-solicitacao.scss?vue&type=style&index=0&id=775dc291&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775dc291",
  null
  
)

export default component.exports